<template>
  <div>
    <sui-button color="blue" icon="arrow left" label-position="left" @click="goBack($event, '/')">{{$t('btnBack')}}</sui-button>
    <sui-segment raised>
      <h2 class="sui-header" color="red" align="center">{{$t('labelHelp')}}</h2>
      <sui-tab :menu="{ vertical: true, fluid: true}">
        <sui-tab-pane :title="$t('cat1Label')">
          <Zugangskarten />
        </sui-tab-pane>
        <sui-tab-pane :title="$t('cat2Label')">
          <Zugangsprobleme />
        </sui-tab-pane>
        <sui-tab-pane :title="$t('cat3Label')">
          <Verschiedenes />
        </sui-tab-pane>
      </sui-tab>
    </sui-segment>
  </div>
</template>

<script>
  import Zugangskarten from '@/views/help/Zugangskarten.vue'
  import Zugangsprobleme from '@/views/help/Zugangsprobleme.vue'
  import Verschiedenes from '@/views/help/Verschiedenes.vue'

  export default {
    name: 'Help',
    components: {
      Zugangskarten,
      Zugangsprobleme,
      Verschiedenes
    },
    metaInfo() {
      return {
        title: this.$t('labelHelp'),
        meta: [
          /*{ vmid: 'description', name: 'description', content: this.data.content }*/
        ]
      }
    },
    data() {
      return {
        fromRoute: null
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fromRoute = from;
      })
    },
    methods: {
      goBack(event, fallback) {
        if (event) {
          event.preventDefault()
        }
        if (this.fromRoute == null || !this.fromRoute.name) {
          this.$router.push(fallback);
        } else {
          this.$router.back();
        }
      }
    },
  };
</script>
